import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

export interface ContextLimitModalState {
  shouldShowContextLimitModal: boolean;
}

const initialState = {
  shouldShowContextLimitModal: false,
} as ContextLimitModalState;

export const contextLimitModalSlice = createSlice({
  name: 'contextLimitModal',
  initialState,
  reducers: {
    setShouldShowContextLimitModal: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.shouldShowContextLimitModal = payload;
    },
  },
});

export const contextLimitModalState = (state: RootState) =>
  state.contextLimitModal as ContextLimitModalState;

export const { setShouldShowContextLimitModal } =
  contextLimitModalSlice.actions;

export default contextLimitModalSlice.reducer;
